import React from "react";
import smlLogo from "../images/sml_sign_rgb_1024.png";
import Image from "antd/lib/image";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Typography from "antd/lib/typography";
import Divider from "antd/lib/divider";

const { Title, Paragraph } = Typography;

const Footer: React.FC = () => (
    <>
        <Divider />
        <Row justify="center">
            <Col span={4}>
                <a
                    href="https://softwaremill.com"
                    target="_blank"
                    rel="noreferrer"
                    title="Created by SoftwareMill"
                >
                    <Image src={smlLogo} alt="SoftwareMill" preview={false} />
                </a>
            </Col>
        </Row>
        <Row justify="center">
            <Title level={5}>Created by SoftwareMill</Title>
            <Paragraph>
                <a
                    href="https://softwaremill.com/services/big-data-and-machine-learning/"
                    target="_blank"
                    rel="noreferrer"
                >
                    SoftwareMill
                </a>{" "}
                offers architecture, development and consulting services for
                projects leveraging (or considering) Apache Kafka as well as
                tailored training programs.
            </Paragraph>
        </Row>
        <Divider />
    </>
);

export default Footer;
